import { createAction } from "@reduxjs/toolkit";

import { FETCH, DONE, FAIL, SCHEDULE } from "../../constants";

export const fetchScheduleAction = createAction<any | undefined>(SCHEDULE + FETCH);
export const fetchScheduleActionDone = createAction<any>(SCHEDULE + FETCH + DONE);
export const fetchScheduleActionFail = createAction<undefined>(SCHEDULE + FETCH + FAIL);

